import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  to?: string;
  linkLabel?: string;
}

export default function SectionHeading({ eyebrow, title, description, to, linkLabel }: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
            <span className="flex h-3 w-3 items-center justify-center">
              <i className="ri-flashlight-fill w-3 h-3 flex items-center justify-center"></i>
            </span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>
        )}
      </div>
      {to && linkLabel && (
        <Link
          to={to}
          className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          {linkLabel}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </span>
        </Link>
      )}
    </div>
  );
}